// extracted by mini-css-extract-plugin
export default {"cls1":"Attachment-cls1_EtQ","cls2":"Attachment-cls2_wKO Attachment-cls1_EtQ"};